import { FIELD_TYPES } from "constants/template-field-type";
import ProductCardConfig from "segments/desktop/core-components/product-card/fields-config";
import ThemeConfig from "segments/core-configs/theme-config";

export default {
  type: FIELD_TYPES.NESTED,
  label: "Products Cards",
  fields: {
    ...ThemeConfig,
    cards: {
      type: FIELD_TYPES.MULTIPLE_NESTED,
      label: "Use cases",
      nestedConfig: {
        type: FIELD_TYPES.NESTED,
        fields: ProductCardConfig.fields
      }
    }
  }
};
